

exports.__esModule = true;
exports.$xoCvvDirective = void 0;
var _squid = require("squid");
var _cardMetaData = require("../cardMetaData");
var _logger = require("xo-beaver/dist/logger");
require("xo-ui-components/src/floating-label/directive");
require("xo-ui-components/src/directionality/directive");
var _template = _interopRequireDefault(require("./template.html"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var $xoCvvDirective = exports.$xoCvvDirective = _squid.$Component.extend('$xoCvvDirective', {
  tag: 'xo-cvv',
  template: _template["default"],
  props: {
    card: {
      type: 'var',
      required: false
    },
    showLabel: {
      type: 'var',
      required: false
    }
  },
  lifecycle: {
    enter: function enter() {
      var _this = this;
      this.focusAndBlurHandler = function ($event) {
        _logger.$logger.info("credit_card_cvv_" + $event.type + "_event");
      };
      this.maskCVV = (0, _squid.$feature)('maskCVV', false, _squid.$locale.country);
      this.cvvLength = function () {
        // passing country to differentiate CUP for C2 and ROW
        return _cardMetaData.$CardMetaData.getMetaData(_this.props.card, 'length.cvv', _squid.$locale.country);
      };
      this.cvvRequired = function () {
        return _this.props.card.type !== 'MAESTRO' || (0, _squid.$feature)('maestroCvvRequired', false, _squid.$locale.country);
      };
    }
  }
});
angular.value("$xoCvvDirective", $xoCvvDirective);
_squid.$Component;
_squid.$locale;
_squid.$feature;
_cardMetaData.$CardMetaData;
_logger.$logger;


//////////////////
// WEBPACK FOOTER
// ../node_modules/xo-wallet-components/src/add-card/cvv/directive.js
// module id = ../node_modules/xo-wallet-components/src/add-card/cvv/directive.js
// module chunks = 0